export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
export const SEARCH_URL = import.meta.env.VITE_SEARCH_API_BASE_URL
export const WHATSAPP_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER
export const AGENT_NUMBER = "+221784575757"
export const AGENT_NUMBER_SN = "784575757"
